import create from "zustand";

const initialState = Object.freeze({
	decodedJwt: undefined,
});

const useStore = create((set) => ({
	...initialState,

	setDecodedJwt: (val) => {
		set(() => ({
			decodedJwt: val
		}));
	},
	reset: () => {
		set(() => ({ ...initialState }));
	},
}));

export default useStore;
